
    import { defineComponent, computed } from "vue";
    import { useStore } from '../store'
    import Tile from './Tile.vue'

    export default defineComponent({
        name: "ItemList",
        components: {
            Tile
        },
        setup() {
            const store = useStore()

            return {
                items: computed(() => store.state.searchResult?.items),
            }
        }
    });
